import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import classNames from 'classnames';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import  {putData } from '../ApiCalls/DataApis';
import { connect} from "react-redux";
import {showSuccessSnackbar, showErrorSnackbar} from '../store/actions/snackbarActions';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';



const styles = theme => ({
  paper: {
    position: 'relative',
    width: theme.spacing(50),
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(0),
    borderRadius: '10px',
    [theme.breakpoints.down('sm')]:{
      width: theme.spacing(43),
    }
  },
  button: {
    width: 'auto',
    height: 'auto',
    padding: '4px',
    margin: '0px',
    border:'0px solid #4f86ce',
    justifyContent: 'flex-end',
    alignItems:'flex-end',
    alignItems: 'flex-end',
    fontFamily:'Trebuchet MS',
    outline: 'none',
    '&:active': {
      outline: 'none',
    },
    '&:focus': {
      outline: 'none',
    },
  },
  buttonSuccess: {
    backgroundColor: green[500],
    color: '#fafafa',
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  dialog: { borderRadius: 10 } ,
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

class EditRemoteConnectionModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      loading: false,
      success: false,
      connectionInfo: this.props.connectionInfo,
      remoteConnectionFromIp: this.props.connectionInfo.device_connection_from_ip,
      remoteConnectionPort: this.props.connectionInfo.device_connection_from_port,
      remoteConnectionSlug: this.props.connectionInfo.device_connection_slug,
    };

    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.submitButtonClick = this.submitButtonClick.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      connectionInfo: nextProps.connectionInfo,
      remoteConnectionFromIp: nextProps.connectionInfo.device_connection_from_ip,
      remoteConnectionPort: nextProps.connectionInfo.device_connection_from_port,
      remoteConnectionSlug: nextProps.connectionInfo.device_connection_slug,
    }); 
  };

  handleOpen = () => {
    this.setState({ 
      open: true,
      loading: false,
      success: false,
    });
  };

  handleClose = () => {
    this.setState({ 
      open: false,
      loading: false,
      success: false,
      // connectionInfo: [],
      // remoteConnectionPort: '',
      // remoteConnectionSlug: '',
    });
  };

  handleRemoteConnectionPortChange = (event) => {
    this.setState({remoteConnectionPort: event.target.value});
  }
  handleRemoteConnectionFromIpChange = (event) => {
    this.setState({remoteConnectionFromIp: event.target.value});
  }

  handleRemoteConnectionSlugChange = (event) => {
    // https://www.w3schools.com/jsref/jsref_obj_regexp.asp
    this.setState({remoteConnectionSlug: event.target.value.replace(/[^a-z0-9-]/g, "")});
  }

  submitButtonClick = () => {
    const { loading } = this.state;
    if (!loading) {
      this.setState(
        {
          success: false,
          loading: true,
        },
        () => {
          console.log('this.props.connectionInfo.device_connection_from_ip' )
          console.log(this.props.connectionInfo.device_connection_from_ip )
          console.log(this.props.connectionInfo.device_connection_from_port )
          console.log('this.state.remoteConnectionPort')
          console.log(this.state.remoteConnectionPort)
          console.log(this.state.remoteConnectionFromIp)
          console.log(this.state.remoteConnectionSlug)
          console.log('https://api.iotflows.com/v1/devices/' + this.props.connectionInfo.device_uuid + '/connections/ip/' + this.props.connectionInfo.device_connection_from_ip  + '/port/'+ this.props.connectionInfo.device_connection_from_port )
        putData('https://api.iotflows.com/v1/devices/' + this.props.connectionInfo.device_uuid + '/connections/ip/' + this.props.connectionInfo.device_connection_from_ip  + '/port/'+ this.props.connectionInfo.device_connection_from_port , 
        {'new_port': this.state.remoteConnectionPort,
          'new_ip': this.state.remoteConnectionFromIp,
          'slug': this.state.remoteConnectionSlug})
          .then(async response => {
            if(response.ok){
              this.props.showSuccessSnackbar("Remote connection has been successfully modified!");
              this.props.refreshRemoteConnectionList();
              this.setState({
                loading: false,
                success: true,
                open:false,
              }, ()=> {this.handleClose()});
            }
            else{
              try{
                const data = await response.json();
                this.props.showErrorSnackbar(data.message);
                this.setState({
                  loading: false,
                  success: false,
                  open:false,
                }, ()=> {this.handleClose()});
              }catch (e){
                this.props.showErrorSnackbar('Something went wrong');
              }
            }
          })
        }
      )
    }
  };



  render() {
    const { classes } = this.props;
    const { open, 
            loading, 
            success, 
            remoteConnectionPort,
            remoteConnectionFromIp,
            remoteConnectionSlug} = this.state;

    const buttonClassname = classNames({
      [classes.buttonSuccess]: success,
    });
    

    return (
      <Grid
        container
        alignItems="flex-end"
        justify="flex-end"
        direction="column"
      >
        
        <IconButton className={classes.button} variant="outlined" onClick={this.handleOpen}><EditOutlinedIcon style={{color: '#757575'}}/></IconButton>

          <Dialog
              open={open}
              onClose={this.handleClose}
              TransitionComponent={Transition}
              keepMounted
              classes = {{paper: classes.dialog}}
            >
              <Paper className={classes.paper} >
                <DialogTitle style={{paddingBottom: '0px'}} >Edit IoT API Key</DialogTitle>
                <DialogContent dividers style={{paddingBottom: '20px', paddingTop: '0px'}}>
                <TextField
                  autoFocus
                  margin="normal"
                  label="From Ip"
                  type="text"
                  value={remoteConnectionFromIp} 
                  onChange={this.handleRemoteConnectionFromIpChange}
                  fullWidth
                />
                <TextField
                  autoFocus
                  margin="normal"
                  label="Port Number"
                  type="text"
                  value={remoteConnectionPort} 
                  onChange={this.handleRemoteConnectionPortChange}
                  fullWidth
                />

                <TextField
                  autoFocus
                  margin="normal"
                  label="Slug"
                  type="text"
                  value={remoteConnectionSlug} 
                  onChange={this.handleRemoteConnectionSlugChange}
                  fullWidth
                />

                </DialogContent>
                <DialogActions style={{justifyContent:'flex-end'}}>
                  <Button onClick={this.handleClose} >
                    Close
                  </Button>
                  <Button  color="primary" type='submit' className={buttonClassname} disabled={loading} onClick={this.submitButtonClick}>
                    Submit { loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                  </Button>
                </DialogActions>
              </Paper>
         
        </Dialog>
        
      </Grid>
    );
  }
}


const mapDispatchToProps = dispatch => ({
  showSuccessSnackbar: message => dispatch(showSuccessSnackbar(message)),
  showErrorSnackbar: message => dispatch(showErrorSnackbar(message)),

})
const mapStateToProps = state => {
  return {
    selectedOrganization: state.organizations.selectedOrganization,

  }
}

export default connect(mapStateToProps,mapDispatchToProps)(withStyles(styles)(EditRemoteConnectionModal));
